export default __webpack_public_path__ + "static/b4-330c11235d3cc25e3b2abd07c0162928.png";